const Menu = [
  {
    path: "/dashboard",
    icon: "fa fa-th",
    title: "Dashboard"
  },
  {
    path: "/knowledgeDomains",
    icon: "fa fa-hdd",
    title: "Knowledge Domains"
    // children: [
    //   { path: '/knowledgeDomains/jee', title: 'JEE' },
    //   { path: '/knowledgeDomains/advanced', title: 'Advanced' },
    //   { path: '/knowledgeDomains/neet', title: 'NEET' }
    // ]
  },
  {
    path: "/login",
    icon: "fa fa-hdd",
    title: "Login"
    // children: [
    //   { path: '/knowledgeDomains/jee', title: 'JEE' },
    //   { path: '/knowledgeDomains/advanced', title: 'Advanced' },
    //   { path: '/knowledgeDomains/neet', title: 'NEET' }
    // ]
  },
  {
    path: "/courses",
    icon: "fab fa-simplybuilt",
    title: "Courses"
  },
  {
    path: "/ui",
    icon: "fa fa-gem",
    title: "Admin Activity"
  },
  {
    path: "/bootstrap-4",
    icon: "fa fa-gem",
    title: "Students"
  },
  {
    path: "/form",
    icon: "fa fa-list-ol",
    title: "Orders"
  },
  {
    path: "/table",
    icon: "fa fa-table",
    title: "Logout"
  }
];

export default Menu;
